export default __webpack_public_path__ + "static/media/@laisrams.43449045.jpg";